import React from 'react';
import styles from './GstOverview.module.scss';
import { GstOverviewResponse } from '../../../../store/dashboard/gstOverview/types';
import LoadingSpinner from '../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import KpiStrip from './KpiStrip';
import AnnualTurnoverRangeChart from './AnnualTurnoverRangeChart';
import StatesMap from './StatesMap';
import GstinTable from './GstinTable';
import { noDataFoundEmptyState } from '../../../../assets/hostedassets';

function NoDataPanel() {
    return (
        <div className={styles.NoDataPanel}>
            <img className={styles.NoDataIllustration} src={noDataFoundEmptyState} alt="" aria-hidden />
            <div className={styles.NoDataText}>No data available</div>
        </div>
    );
}

export function hasAnyGstData(data: GstOverviewResponse | null): boolean {
    if (!data) return false;
    const rows = data.rows ?? [];
    const summary = data.summary;
    if (rows.length > 0) return true;
    if ((summary?.totalGstinCount ?? 0) > 0) return true;
    if ((summary?.stateCoverage?.totalStates ?? 0) > 0) return true;
    if ((summary?.yoYTurnover?.length ?? 0) > 0) return true;
    return false;
}

interface GstDetailsBodyProps {
    loading: boolean;
    error: string | null;
    data: GstOverviewResponse | null;
}

function GstDetailsBody({ loading, error, data }: Readonly<GstDetailsBodyProps>) {
    if (loading) {
        return (
            <div className={styles.LoadingWrap}>
                <LoadingSpinner color="var(--primary-text-colour)" height="32px" />
            </div>
        );
    }

    if (error) {
        return <NoDataPanel />;
    }

    if (!hasAnyGstData(data)) {
        return <NoDataPanel />;
    }

    const { summary, rows } = data!;

    return (
        <div className={styles.GstOverview}>
            <div className={styles.TopGrid}>
                <div className={styles.LeftCol}>
                    <KpiStrip summary={summary} />
                    <AnnualTurnoverRangeChart summary={summary} />
                </div>
                <div className={styles.RightCol}>
                    <StatesMap summary={summary} rows={rows} />
                </div>
            </div>
            <GstinTable rows={rows} />
        </div>
    );
}

export default GstDetailsBody;
